"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
var _config = require("./config");
var _util = require("./util");
var _tableColumn = _interopRequireDefault(require("./tableColumn"));
var _tablePagination = _interopRequireDefault(require("./tablePagination"));
var _default = exports.default = {
  name: 'CommonTable',
  components: {
    tableColumn: _tableColumn.default,
    tablePagination: _tablePagination.default
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    },
    loading: Boolean,
    config: {
      type: Object,
      default: () => ({})
    },
    pageConfig: {
      type: Object,
      default: () => ({})
    },
    page: {
      type: Object,
      default: () => null
    },
    // Table 的尺寸 默认 default 48 / medium 44 / small 40 / mini 36
    size: {
      type: String,
      default: 'small'
    },
    maxHeight: {
      type: String,
      default: () => 'auto'
    }
  },
  data() {
    return {
      selection: []
    };
  },
  computed: {
    _config() {
      return Object.assign({
        showHandler: false,
        handlerColumn: {},
        highlightSelect: true,
        showIndexColumn: false,
        tooltipEffect: 'dark'
      }, this.config);
    },
    // 操作列配置
    handlerColumn() {
      return Object.assign({
        label: '操作',
        minWidth: 200,
        fixed: 'right'
      }, this._config.handlerColumn);
    },
    // el-table组件属性
    elAttrs() {
      const copy = {};
      for (const key in this._config) {
        if (_config.elTableAttrs.includes(key)) {
          copy[key] = this._config[key];
        }
      }
      if (this._config.highlightSelect) {
        Object.assign(copy, {
          'row-class-name': this.rowClassName
        });
      }
      return copy;
    },
    // el-table监听事件
    listeners() {
      return Object.assign({}, this.$listeners, {
        select: this.handleSelect,
        'select-all': this.handleSelectAll
      });
    }
  },
  watch: {
    // 如果当前数据有已被选中的则设置为已勾选
    data(val) {
      this.$nextTick(() => {
        if (val.length > 0 && this.selection.length > 0) {
          val.forEach(row => {
            if (this.selection.findIndex(item => this._getRowKey(item) === this._getRowKey(row)) >= 0) {
              this.$refs.table.toggleRowSelection(row, true);
            }
          });
        }
      });
    }
  },
  methods: {
    _getRowKey(row) {
      const config = this._config;
      if (typeof config.rowKey === 'function') {
        return config.rowKey(row);
      } else if (typeof config.rowKey === 'string') {
        return (0, _util.get)(row, config.rowKey);
      }
      return row.id;
    },
    handleCurrentChange(val) {
      this.$emit('current-page-change', val);
    },
    handleSizeChange(val) {
      this.$emit('page-size-change', val);
    },
    handleSelect(selection, row) {
      if (selection.includes(row)) {
        this.selection.push(row);
      } else {
        this.selection.splice(this.selection.indexOf(row), 1);
      }
      this.$emit('select', this.selection, row);
    },
    handleSelectAll(selection) {
      let index;
      this.data.forEach(row => {
        index = this.selection.findIndex(item => this._getRowKey(item) === this._getRowKey(row));
        // 全选时
        if (selection.length > 0 && index < 0) {
          this.selection.push(row);
          // 全不选时
        } else if (selection.length === 0 && index >= 0) {
          this.selection.splice(index, 1);
        }
      });
      this.$emit('selectAll', this.selection);
    },
    // 高亮当前选中行
    rowClassName({
      row
    }) {
      for (let index = 0; index < this.selection.length; index++) {
        if (this.selection[index] === row) {
          return 'row__active';
        }
      }
      return '';
    },
    clearSelection() {
      this.selection = [];
      this.$refs.table.clearSelection();
    },
    toggleRowSelection() {
      return this.$refs.table.toggleRowSelection(...arguments);
    },
    toggleAllSelection() {
      return this.$refs.table.toggleAllSelection(...arguments);
    },
    toggleRowExpansion() {
      return this.$refs.table.toggleRowExpansion(...arguments);
    },
    setCurrentRow() {
      return this.$refs.table.setCurrentRow(...arguments);
    },
    clearSort() {
      return this.$refs.table.clearSort(...arguments);
    },
    clearFilter() {
      return this.$refs.table.clearFilter(...arguments);
    },
    doLayout() {
      return this.$refs.table.doLayout(...arguments);
    },
    sort() {
      return this.$refs.table.sort(...arguments);
    }
  }
};